import { useMemo } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { resolveWorkspaceLinkUrl } from "apps/project-iq/utils/resolveWorkspaceLinkUrl";
import { getLinks } from "apps/project-iq/api";
import { IAdminLink, LinkCategory } from "apps/project-iq/models/IAdminLink";

export interface IUseLinksResult {
  links: IAdminLink[];
  isLoading: boolean;
  isError: boolean;
}

export const useLinks = (category: LinkCategory): IUseLinksResult => {
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { data, isLoading, isError } = useQuery<IAdminLink[], Error>({
    queryKey: ["links"],
    queryFn: () => getLinks(),
  });

  const links = useMemo(
    () =>
      (data ?? [])
        .filter((link) => link.category === category)
        .map((link) => ({
          ...link,
          url: resolveWorkspaceLinkUrl(link.url, workspaceId),
        })),
    [data, category, workspaceId],
  );

  return { links, isLoading, isError };
};
